export const AuthRolesEnum = {
    SystemAdmin: "systemadmin",
    Licensee: "licensee",
    ListAdmin: "listadmin",
    Broker: "listadmin", // Alias for ListAdmin (UI terminology)
    ListOwner: "listowner",
    PafAdmin: "pafadmin",
    PafUser: "pafuser",
    UserAdmin: "useradmin",
    BrokerAgent: "brokeragent",
};

export type AuthRolesType = typeof AuthRolesEnum[keyof typeof AuthRolesEnum];